import Vue from 'vue'
import VueRouter from  'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '../components/Home/Home'
const Login = () => import("../components/Auth/Login")

// import Login from '../components/Auth/Login'
import Register from '../components/Auth/Register'
import Profile from '../components/User/Profile'
import MyCourses from '../components/User/MyCourses'
import MyCourseDetails from '../components/User/MyCourseDetails'

import ForgetPassword from '../components/Auth/ForgetPassword'
import ResetPassword from '../components/Auth/ResetPassword'
import AboutUsEnglish from '../components/Pages/AboutUsEnglish' 
import PrivacyPolicy from '../components/Pages/PrivacyPolicy' 
import TermsAndConditions from '../components/Pages/TermsAndConditions' 
import AboutUsArabic from '../components/Pages/AboutUsArabic' 
import FAQ from '../components/Pages/Faq' 
import Mission from '../components/Pages/Mission' 
import Vision from '../components/Pages/Vision' 
import CoreValues from '../components/Pages/CoreValues' 
import MedicalTrainingCenter from '../components/Pages/MedicalTrainingCenter' 
import NamaLearningManagement from '../components/Pages/NamaLearningManagement'
import DigitalHealthSolutions from '../components/Pages/DigitalHealthSolutions' 
import ConsultancyServices from '../components/Pages/ConsultancyServices' 
import ContactUs from '../components/Pages/ContactUs' 
import Thankyou from '../components/Pages/Thankyou' 
import WhatWeDo from '../components/Pages/WhatWeDo' 
import NewsInsightsListing from '../components/News/NewsInsightsListing' 
import NewsInsightsDetails from '../components/News/NewsInsightsDetails'
import CoursesListing from '../components/Courses/CoursesListing'
import CourseDetails from '../components/Courses/CourseDetails'
import CartPage from '../components/Checkout/CartPage'
import Checkout from '../components/Checkout/Checkout'
import OrderResponse from '../components/Checkout/OrderResponse'
import HospitalInformationSystem from '../components/Pages/HospitalInformationSystem'

import Search from '../components/Search'
import i18n from "@/i18n"

Vue.use(VueRouter)

const routes = [
    /*{
        path: '/',
        redirect: '/'
    },*/
    {
        path:'/',
        component:{
            render (c){ return c('router-view') }
        },
       // beforeEnter: (to,from,next) => {
            // const locale = to.params.lang; // 1
            // const supported_locales = ['en','ar']; // 2
            // if (!supported_locales.includes(locale)) return next('en'); // 3

            // if (i18n.locale !== locale) { // 4
            //   i18n.locale = locale;
            // }
            // if(i18n.locale=='en'){
            //       document.body.classList.add('site-english');
            //       document.body.classList.remove('site-arabic');
            //   }
            //   else{
            //       document.body.classList.add('site-arabic');
            //       document.body.classList.remove('site-english');
            //   }

              
           // return next() //
       // },
        children:[
            {
              path: '/',
              name: 'Home',
              component: Home,
              meta:{
                type:'page',
                slug:'/'
              }
            },
            {
                path: 'search',
                name: 'Search',
                component: Search
            },
            {
              path: 'login',
              name: 'Login',     
              component: Login,
              meta:{
                type:'page',
                slug:'login'
              }
            },
            {
              path: 'register',
              name: 'Register',
              component: Register,
              meta:{
                type:'page',
                slug:'register'
              }
            },
            {
              path: 'profile',
              name: 'Profile',
              component: Profile,
              meta:{
                type:'page',
                slug:'profile'
              }
            },
            {
              path: 'my-courses',
              name: 'MyCourses',
              component: MyCourses,
              meta:{
                type:'page',
                slug:'my-courses'
              }
            },
            {
              path:'my-courses/:id',
              name: 'MyCourseDetails',
              component: MyCourseDetails,
              meta:{
                type:'page',
                slug:'my-courses'
              }
            },
            {
              path: 'forget-password',
              name: 'ForgetPassword',
              component: ForgetPassword,
              meta:{
                type:'page',
                slug:'forget-password'
              }
            },
            {
              path: 'reset-password-form/:token',
              name: 'ResetPassword',
              component: ResetPassword,
              meta:{
                type:'page',
                slug:'reset-password'
              }
            },
            {
              path:'mission',
              name: 'Mission',
              component: Mission,
              meta:{
                type:'page',
                slug:'mission'
              }
            },
            {
              path:'vision',
              name: 'Vision',
              component: Vision,
              meta:{
                type:'page',
                slug:'vision'
              }
            },
            {
              path:'core-values',
              name: 'CoreValues',
              component: CoreValues,
              meta:{
                type:'page',
                slug:'core-values'
              }
            },
            {
              path:'about-us-arabic',
              name: 'AboutUsArabic',
              component: AboutUsArabic,
              meta:{
                type:'page',
                slug:'about-us-arabic'
              }
            },
            {
              path:'what-we-do',
              name: 'WhatWeDo',
              component: WhatWeDo,
              meta:{
                type:'page',
                slug:'what-we-do'
              }
            },
            {
              path:'about-us',
              name: 'AboutUsEnglish',
              component: AboutUsEnglish,
              meta:{
                type:'page',
                slug:'about-us'
              }
            },
            {
              path:'privacy-policy',
              name: 'PrivacyPolicy',
              component: PrivacyPolicy,
              meta:{
                type:'page',
                slug:'privacy-policy'
              }
            },
            {
              path:'terms-and-conditions',
              name: 'TermsAndConditions',
              component: TermsAndConditions,
              meta:{
                type:'page',
                slug:'terms-and-conditions'
              }
            },
            {
              path:'faq',
              name: 'FAQ',    
              component: FAQ,
              meta:{
                type:'page',
                slug:'faq'
              }
            },
            {
              path:'medical-training-center',
              name: 'MedicalTrainingCenter',
              component: MedicalTrainingCenter,
              meta:{
                type:'page',
                slug:'medical-training-center'
              }
            },
            {
              path:'nama-learning-management',
              name: 'NamaLearningManagement',
              component: NamaLearningManagement,
              meta:{
                type:'page',
                slug:'nama-learning-management'
              }
            },
            {
              path:'digital-health-solutions',
              name: 'DigitalHealthSolutions',
              component: DigitalHealthSolutions,
              meta:{
                type:'page',
                slug:'digital-health-solutions'
              }
            },
            {
              path:'consultancy-services',
              name: 'ConsultancyServices',
              component: ConsultancyServices,
              meta:{
                type:'page',
                slug:'consultancy-services'
              }
            },
            {
              path:'contact-us',
              name: 'ContactUs',
              component: ContactUs,
              meta:{
                type:'page',
                slug:'contact-us'
              }
            },
            {
              path:'thank-you/',
              name: 'Thankyou',
              component: Thankyou,
              meta:{
                type:'page',
                slug:'thank-you'
              }
            },
            {
              path:'news',
              name: 'NewsInsightsListing',
              component: NewsInsightsListing,
              meta:{
                type:'page',
                slug:'news'
              }
            },
            {
              path:'news/:slug',
              name: 'NewsInsightsDetails',
              component: NewsInsightsDetails,
              meta:{
                type:'page',
                slug:'news'
              }
            },
            {
              path:'courses/:slug',
              name: 'CourseDetails',
              component: CourseDetails,
              meta:{
                type:'course',
                slug:'course-details'
              }
            },
            {
              path:'courses',
              name: 'CoursesListing',
              component: CoursesListing,
              meta:{
                type:'page',
                slug:'courses'
              }
            },
            {
              path:'cart',
              name: 'CartPage',
              component: CartPage,
              meta:{
                type:'page',
                slug:'cart'
              }
            },
            {
              path:'checkout/:slug/',
              name: 'Checkout',
              component: Checkout,
              meta:{
                type:'page',
                slug:'checkout'
              }
            },
            {
              path:'order-response',
              name: 'OrderResponse',
              component: OrderResponse,
              meta:{
                type:'page',
                slug:'order-response'
              }
            },
            {
              path:'hospital-information-system',
              name: 'HospitalInformationSystem',
              component: HospitalInformationSystem,
              meta:{
                type:'page',
                slug:'hospital-information-system'
              }
            }
            

        ]
    }
];     
const router = new VueRouter({
  mode: 'history',
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



router.beforeEach((to, from, next) => {
    window.scrollTo(0,0);
    next();
})
            

export default router        
              


// WEBPACK FOOTER //
// ./src/router/index.js